import { render, staticRenderFns } from "./associationCoupon.vue?vue&type=template&id=23d0059b&scoped=true&"
import script from "./associationCoupon.vue?vue&type=script&lang=js&"
export * from "./associationCoupon.vue?vue&type=script&lang=js&"
import style0 from "./associationCoupon.vue?vue&type=style&index=0&id=23d0059b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0059b",
  null
  
)

export default component.exports